<template>
  <div id="app" class="app">
    <keep-alive :include="$store.state.keys">
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import { validateMixin } from '@/mixins/validate'
import { removeLocalStorage, getLocalStorage } from '@/utils'

export default {
  name: 'App',
  data () {
    return {
      include: []
    }
  },
  watch: {
    '$route'(val) {
      let include = this.$store.state.keys
      if (val.meta.keepAlive && val.meta.key) {
        const name = val.meta.key                       // 需要缓存的页面 meta.key 需和页面的name一致
        if (name && !include.includes(name)) {
          include.push(name)
          this.$store.commit('KEYS',include)            // store 中存入需要缓存的页面
        }
      }
    }
  },
  components: {
    
  },
  methods: {
    
  },
  created () {
    removeLocalStorage(this.$store.state.userCard)
    // this.$store.commit('DEFAULTDATE', {
		// 	startDate: this.$moment().format('YYYY-MM-DD'),
		// 	endDate: this.$moment().add(1, 'day').format('YYYY-MM-DD'),
		// 	startWeekday: this.$moment().format('dddd'),
		// 	endWeekday: this.$moment().add(1, 'day').format('dddd'),
		// 	seletDays:1,
		// })
    // this.$store.commit('ROOMNUMBER', {
		// 	rooms: 1,
		// 	adult: 2,
		// 	child: 0
		// })
  },
  mounted () {
    let vh = window.innerHeight * 0.01
    let vw = window.innerWidth * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    document.documentElement.style.setProperty('--vw', `${vw}px`)

    // We listen to the resize event
    window.addEventListener('resize', () => { 
      // We execute the same script as before
      let vh = window.innerHeight * 0.01
      let vw = window.innerWidth * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
      document.documentElement.style.setProperty('--vw', `${vw}px`)
    })
  }
}
</script>

<style lang='less'>
  @import "~@/assets/iconfont.less";
  @import "~@/assets/app.less";
</style>




// WEBPACK FOOTER //
// src/App.vue